import React from "react";

export default function MateriasForm({
  modo = "crear", // 'crear' o 'editar'
  form = {},
  setForm = () => {},
  onSubmit = () => {},
  loading = false,
  onCancel = () => {},
  formId = "materias-form",
  showActions = true,
}) {

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const isCreateMode = modo === "crear";

  return (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      noValidate
      className="materias-form"
    >
      {/* Nombre */}
      <div className="mb-3">
        <label htmlFor="nombre" className="form-label">
          Nombre de la materia
          <span className="text-danger ms-1">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="nombre"
          placeholder="Ej: Primeros Auxilíos"
          value={form.nombre || ""}
          onChange={(e) => handleChange("nombre", e.target.value)}
          maxLength="200"
          required
          disabled={loading}
        />
        <small className="text-muted d-block mt-1">
          Máximo 200 caracteres {form.nombre?.length || 0}/200
        </small>
      </div>

      {/* Sigla */}
      <div className="mb-3">
        <label htmlFor="sigla" className="form-label">
          Sigla
          <span className="text-muted ms-1">(Opcional)</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="sigla"
          placeholder="Ej: BD, PRG, MAT"
          value={form.sigla || ""}
          onChange={(e) => handleChange("sigla", e.target.value)}
          maxLength="20"
          disabled={loading}
        />
        <small className="text-muted d-block mt-1">
          Máximo 20 caracteres {form.sigla?.length || 0}/20
        </small>
      </div>

      {/* Descripción */}
      <div className="mb-3">
        <label htmlFor="descripcion" className="form-label">
          Descripción
          <span className="text-muted ms-1">(Opcional)</span>
        </label>
        <textarea
          className="form-control"
          id="descripcion"
          placeholder="Describe brevemente el contenido de la materia"
          rows="3"
          value={form.descripcion || ""}
          onChange={(e) => handleChange("descripcion", e.target.value)}
          disabled={loading}
        />
        <small className="text-muted d-block mt-1">
          Ayuda a identificar el propósito de la materia
        </small>
      </div>

      {/* Color Hexadecimal */}
      <div className="mb-3">
        <label htmlFor="color_hex" className="form-label">
          Color para cronogramas
          <span className="text-muted ms-1">(Opcional)</span>
        </label>
        <div className="input-group">
          <input
            type="color"
            className="form-control form-control-color"
            id="color_picker"
            value={/^#[0-9A-Fa-f]{6}$/.test(form.color_hex) ? form.color_hex : '#3B82F6'}
            onChange={(e) => handleChange("color_hex", e.target.value.toUpperCase())}
            disabled={loading}
            title="Haz clic para abrir el selector de color"
            style={{ width: 48, padding: '2px 4px', cursor: 'pointer' }}
          />
          <input
            type="text"
            className="form-control font-monospace"
            id="color_hex"
            placeholder="#FF5733"
            value={form.color_hex || ""}
            onChange={(e) => {
              const val = e.target.value.toUpperCase();
              if (val === "" || /^#[0-9A-F]{0,6}$/i.test(val)) {
                handleChange("color_hex", val);
              }
            }}
            maxLength="7"
            disabled={loading}
          />
          {form.color_hex && (
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => handleChange("color_hex", "")}
              disabled={loading}
              title="Quitar color"
            >
              <i className="bi bi-x" />
            </button>
          )}
        </div>
        <small className="text-muted d-block mt-1">
          Haz clic en el cuadro de color para abrír el selector completo.
        </small>
      </div>

      {/* Estado */}
      <div className="mb-3">
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="activo"
            checked={form.activo ?? true}
            onChange={(e) => handleChange("activo", e.target.checked)}
            disabled={loading}
          />
          <label className="form-check-label" htmlFor="activo">
            Materia activa
            <small className="text-muted d-block mt-1">
              Las materias inactivas no apareceran en la malla
            </small>
          </label>
        </div>
      </div>

      {showActions && (
        <div className="d-flex gap-2 justify-content-end mt-4">
          <button type="button" className="btn btn-outline-secondary" onClick={onCancel} disabled={loading}>
            Cancelar
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading || !form.nombre?.trim()}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                Guardando...
              </>
            ) : (
              isCreateMode ? "Crear materia" : "Actualizar materia"
            )}
          </button>
        </div>
      )}
    </form>
  );
}
